import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toHandlers as _toHandlers, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "full-width flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-xs" }
const _hoisted_3 = { class: "flex items-center" }

import type KCallout from './KCallout.vue'

interface IProps {
  title?: string
  titleClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  bodyClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  callout?: Record<PropertyKey, unknown> | null
  expandIconToggle?: boolean
  icon?: string
  iconColor?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KAccordion', inheritAttrs: false },
  __name: 'KAccordion',
  props: {
    title: { default: '' },
    titleClass: { default: 'fs-17px' },
    bodyClass: { default: 'q-mt-lg' },
    callout: { default: null },
    expandIconToggle: { type: Boolean, default: false },
    icon: { default: '' },
    iconColor: { default: '' }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_KCallout = _resolveComponent("KCallout")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, _mergeProps({
    "expand-icon-toggle": __props.expandIconToggle,
    "default-opened": "",
    dense: "",
    "dense-toggle": "",
    "hide-expand-icon": "",
    "header-class": "k-accordion bg-off-white-10 q-pa-12 items-center rounded-12"
  }, _ctx.$attrs), {
    header: _withCtx(({ expanded, toggle, show }) => [
      _renderSlot(_ctx.$slots, "header", {
        expanded: expanded,
        toggle: toggle,
        show: show
      }, () => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "before-title"),
            _renderSlot(_ctx.$slots, "title", {
              expanded: expanded,
              toggle: toggle
            }, () => [
              (__props.icon)
                ? (_openBlock(), _createBlock(_component_KIcon, {
                    key: 0,
                    class: "q-mr-xs",
                    name: __props.icon,
                    color: __props.iconColor,
                    size: "28px"
                  }, null, 8 /* PROPS */, ["name", "color"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("p", {
                class: _normalizeClass(["q-mb-none fw-500 text-cool-gray-100", __props.titleClass])
              }, _toDisplayString(__props.title), 3 /* TEXT, CLASS */),
              (__props.callout)
                ? (_openBlock(), _createBlock(_component_KCallout, _mergeProps({
                    key: 1,
                    "container-class": "flex inline"
                  }, __props.callout), null, 16 /* FULL_PROPS */))
                : _createCommentVNode("v-if", true)
            ]),
            _renderSlot(_ctx.$slots, "after-title", {
              expanded: expanded,
              toggle: toggle
            })
          ]),
          _renderSlot(_ctx.$slots, "toggle-icon", {
            expanded: expanded,
            toggle: toggle
          }, () => [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "before-icon", {
                expanded: expanded,
                toggle: toggle
              }),
              _createVNode(_component_KIcon, _mergeProps({
                class: ["k-accordion__toggle-icon cursor-pointer q-pa-xs bg-white rounded-circle transition", { 'rotate-180': expanded }],
                name: expanded ? 'minus' : 'plus',
                color: "cool-gray-70",
                size: "24px"
              }, _toHandlers(__props.expandIconToggle ? { click: toggle } : {})), null, 16 /* FULL_PROPS */, ["class", "name"])
            ])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(__props.bodyClass)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["expand-icon-toggle"]))
}
}

})